module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "records-select"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('orderStatus')) + "：")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordsStatus),
      expression: "recordsStatus"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.recordsStatus)
    },
    on: {
      "input": function($event) {
        _vm.recordsStatus = $event
      }
    }
  }, _vm._l((_vm.recordsStatusOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "block record-date"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v(_vm._s(_vm.$t('orderDate')) + "：")]), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateRange),
      expression: "dateRange"
    }],
    staticClass: "date-range-picker",
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": _vm.$t('selectDateRange'),
      "picker-options": _vm.dateRangeOptions,
      "format": "yyyy/MM/dd"
    },
    domProps: {
      "value": (_vm.dateRange)
    },
    on: {
      "input": function($event) {
        _vm.dateRange = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "store-content"
  }, [(!_vm.loading) ? _c('el-table', {
    staticClass: "records-table",
    attrs: {
      "data": _vm.recordsData,
      "empty-text": _vm.loading ? ' ' : _vm.$t('noRecords')
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderDate",
      "label": _vm.$t('recordDate'),
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.recordsType == 'consume') ? [_c('el-table-column', {
    attrs: {
      "prop": "appName",
      "label": _vm.$t('appName'),
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodsName",
      "label": _vm.$t('goodsName'),
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodsPrice",
      "label": _vm.$t('goodsPrice'),
      "width": "150",
      "align": "center"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.recordsType == 'recharge') ? [_c('el-table-column', {
    attrs: {
      "prop": "channelName",
      "label": _vm.$t('rechargeChannel'),
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rechargeAmount",
      "label": _vm.$t('rechargeAmount'),
      "width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "egPoint",
      "label": _vm.$t('egPoint'),
      "width": "110",
      "align": "center"
    }
  })] : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderId",
      "label": _vm.$t('orderId'),
      "width": "180",
      "align": "center"
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showRecordsBtn && !_vm.loading) ? _c('div', {
    staticClass: "records-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disablePreview
    },
    on: {
      "click": _vm.getPreviewRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('previewPage')) + "\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disableNext
    },
    on: {
      "click": _vm.getNextRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('nextPage')) + "\n            ")])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c6f24a02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/store/Records.vue
// module id = 391
// module chunks = 9